<form [formGroup]="formGroup">
  <table class="table-full-width table-striped">
    @if (featureFlagService.enabled(FeatureFlagService.FLAGS.editEnvelopeInDocusign)()) {
      <tr>
        <td>
          <h2 class="heading-underline">Docusign Settings</h2>
          <form [formGroup]="propertiesForm">
            <mat-slide-toggle id="edit-envelope-enabled" formControlName="editEnvelope">Edit envelope in Docusign</mat-slide-toggle>
          </form>
        </td>
      </tr>
    }
    <tr>
      <td class="input-container-stack">
        <h2 class="heading-underline">Enter new credentials to test or test the stored credentials</h2>
        <label>API Account ID</label>
        <input id="docusign-client-id" formControlName="accountId" type="text" placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx" />
      </td>
    </tr>
    <tr>
      <td class="input-container-stack">
        <label>User ID</label>
        <input
          id="docusign-user-id"
          formControlName="userId"
          type="text"
          placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
          #focusElement
        />
      </td>
    </tr>
    <tr>
      <td>
        <mat-slide-toggle id="docusign-use-demo" formControlName="useDemo">Use Docusign Demo</mat-slide-toggle>
      </td>
    </tr>
  </table>
  <app-button-toast></app-button-toast>
  <section class="footer-btns floating one-button">
    <button type="button" theme="nav" [disabled]="testCredentialsInProgress || !formGroup.valid" (click)="testCredentials()" appRipple>
      <span>Test Credentials</span>
    </button>
  </section>
</form>
